"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT_DEFAULT = exports.themePropTypes = exports.commonPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var spacing = _propTypes["default"].oneOf(["huge", "large", "mediumPlus", "medium", "small", "tiny", "micro", "flush"]);

var children = _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].element), _propTypes["default"].element, _propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array, _propTypes["default"].func]);

var commonPropTypes = {
  spacing: spacing,
  children: children
};
exports.commonPropTypes = commonPropTypes;
var themePropTypes = {
  style: "style",
  component: "component"
};
exports.themePropTypes = themePropTypes;
var VARIANT_DEFAULT = "_default";
exports.VARIANT_DEFAULT = VARIANT_DEFAULT;